import { useState } from "react";

import { Container, InputRadio, Text } from "@jds/core";

export const RadioGroup = (props) => {
  const [selectedValue, setSelectedValue] = useState(props.selectedValue);
  const handleChange = (value) => {
    setSelectedValue(value);
    props?.onChange(value);
  };

  return (
    <Container fullWidth direction="column" gap={16}>
      <Text text="Watermark Type" appearance="body-m-bold" />
      <Container fullWidth gap={16}>
        {props.options.map((option) => (
          <InputRadio
            {...props}
            checked={selectedValue ? selectedValue === option.value : false}
            onClick={() => handleChange(option.value)}
            label={option.label}
            value={option.value}
          />
        ))}
      </Container>
    </Container>
  );
};
